import React from 'react'
import { CmsDynamicPage, CmsStaticPage } from 'crownpeak-dxm-react-sdk';
import DropZone from "../components/functional/dropZone";
import Routing from "../core/routing";
import HeaderNavigation from '../components/global/header-navigation';
import FooterNavigation from '../components/global/footer-navigation';
import { UserProvider } from '../providers/user-provider';
import toast from 'react-toastify';
import config from '../configuration';
import { JsConfig, JsMsalConfig } from '../types';
import BackgroundImage from '../components/global/backgroundImage';
import CountryList from '../components/global/country-list';



export default class KvgHomePage extends CmsStaticPage {

    constructor(props: any) {
        super(props);
        this.cmsSuppressFolder = true;
        this.cmsUseTmf = true;
        this.cmsWrapper = "Kverneland";
        this.cmsUseMetadata = true;
        this.cmsAssetId = Routing.getCmsAssetId(window.location.pathname);

    }



    render() {
        super.render();
        return (
            this.state.isLoaded &&

            <div className={window.localStorage.lang}>
                <div className='kvg-modal'>
                    <CountryList dataProvider={this.cmsDataProvider} />
                </div>
                <header className="kvg-header header">
                    <HeaderNavigation dataProvider={this.cmsDataProvider} />
                </header>

                <main id="main-content" className="main-content" role="main" aria-label="main content">
                    <div className="cp-main-container kvg-wrapper kvg-home">
                        <BackgroundImage dataProvider={this.cmsDataProvider} assetId={this.cmsAssetId} />
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <DropZone name="DragDropZone" />
                                </div>
                                <div className='col-12 home-dropzone-grid'>
                                    <DropZone name="droppable" />
                                </div>

                            </div>
                        </div>
                    </div>


                </main>


                <div className="kvg-footer">
                    <FooterNavigation dataProvider={this.cmsDataProvider} />
                </div>

            </div>

        )
    }
}

